import gray from "./gray";
import red from "./red";

export const cross = {
  "cross/red": red,
  "cross/gray": gray,
};
